import { render, staticRenderFns } from "./container-management.vue?vue&type=template&id=2bd4225d&"
import script from "./container-management.vue?vue&type=script&lang=js&"
export * from "./container-management.vue?vue&type=script&lang=js&"
import style0 from "./container-management.vue?vue&type=style&index=0&id=2bd4225d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports